import { defineMessages } from 'react-intl';

export const scope = 'app.component.base.empty_message_page';

export default defineMessages({
  icon_alt: {
    id: `${scope}.icon_alt`,
    defaultMessage: 'icon',
  },
});
